import { lazy } from 'react';

export const SuccessPage = lazy(() => import('./success'));
export const SuccessVcfcPage = lazy(() => import('./successVcfc'));
